/*
* @requires  ../util/websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function MiddlewareWebsocket(param,m,callback) {
        this.host="ws://127.0.0.1:18210/middleware";
        this.websocket=new $m.createWebSocketWrapper(param,this.host);
        this.setEventCallback(m,callback)
        this.websocket.connect(param);
    }

    MiddlewareWebsocket.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.websocket.setEventCallback(m,callback);
    };

    MiddlewareWebsocket.prototype.reload=function (param) {
        var name="reload";
        var that=this;
        var p={};

        this.websocket.sendMessage({
            fun: 'Reload',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getCerts=function (param) {
        var name="getCerts";
        var that=this;

        var p={};
        $m.util.setAttrsDefault(p,param,["certType"],["sign"]);
        $m.util.setAttrs(p,param,["subjectOids","extOids"]);

        this.websocket.sendMessage({
            fun: 'GetCerts',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.certs);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getCertInfo=function (param) {
        var name="getCertInfo";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["sn","subjectOids","extOids","cert"]);

        this.websocket.sendMessage({
            fun: 'GetCertInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.cert);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.selectCert=function (param) {
        var name="selectCert";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["certType","filter","excludeFilter"]);

        this.websocket.sendMessage({
            fun: 'SelectCert',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.cert);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.sign=function (param) {
        var name="sign";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["sn","data","dataFormat","charset","password"]);

        this.websocket.sendMessage({
            fun: 'Sign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.signBatch=function (param) {
        var name="signBatch";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["sn","data","dataFormat","charset","password"]);

        this.websocket.sendMessage({
            fun: 'SignBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.login=function (param) {
        var name="login";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["sn","password"]);

        this.websocket.sendMessage({
            fun: 'Login',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.logout=function (param) {
        var name="logout";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["sn"]);

        this.websocket.sendMessage({
            fun: 'Logout',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifySign=function (param) {
        var name="verifySign";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["cert","data","dataFormat","charset","signature","context"]);

        this.websocket.sendMessage({
            fun: 'VerifySign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifySignBatch=function (param) {
        var name="verifySignBatch";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["cert","data","dataFormat","charset","signature","context"]);

        this.websocket.sendMessage({
            fun: 'VerifySignBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.certEncrypt=function (param) {
        var name="certEncrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["cert","data","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'CertEncrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.certDecrypt=function (param) {
        var name="certDecrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","encryptData","dataFormat","charset","password"]);

        this.websocket.sendMessage({
            fun: 'CertDecrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getDevices=function(param){
        var name="getDevices";
        var that=this;

        this.websocket.sendMessage({
            fun: 'GetDevices',
            success: function (json) {
                that.websocket.onSuccess(name, param, json.devices);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.selectDevice=function(param){
        var name="selectDevice";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["filter","excludeFilter"]);

        this.websocket.sendMessage({
            fun: 'SelectDevice',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.device);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getDeviceInfo=function(param){
        var name="getDeviceInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId"]);

        this.websocket.sendMessage({
            fun: 'GetDeviceInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.deviceInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getRandom=function(param){
        var name="getRandom";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","randomLength"]);

        this.websocket.sendMessage({
            fun: 'GetRandom',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.random);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getDatas=function(param){
        var name="getDatas";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","path"]);

        this.websocket.sendMessage({
            fun: 'GetDatas',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.datas);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };


    MiddlewareWebsocket.prototype.readData=function(param){
        var name="readData";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","name","path","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'ReadData',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.writeData=function(param){
        var name="writeData";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","name","path","dataFormat","charset","data","isReadNeedLogin"]);

        this.websocket.sendMessage({
            fun: 'WriteData',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.deleteData=function(param){
        var name="deleteData";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","name","path"]);

        this.websocket.sendMessage({
            fun: 'DeleteData',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.genAndWrapperKey=function(param){
        var name="genAndWrapperKey";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","alg","certs"]);

        this.websocket.sendMessage({
            fun: 'GenAndWrapperKey',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.keys);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.genKey=function(param){
        var name="genKey";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","alg"]);

        this.websocket.sendMessage({
            fun: 'GenKey',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.keyId);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.importWrapperKey=function(param){
        var name="importWrapperKey";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","wrapperKey","alg"]);

        this.websocket.sendMessage({
            fun: 'ImportWrapperKey',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.keyId);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.encrypt=function(param){
        var name="encrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyId","data","dataFormat","charset","iv","padding"]);

        this.websocket.sendMessage({
            fun: 'Encrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.encryptStep=function(param){
        var name="encryptStep";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["step","keyId","data","dataFormat","charset","iv","padding"]);

        this.websocket.sendMessage({
            fun: 'EncryptStep',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.decrypt=function(param){
        var name="decrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyId","encryptData","dataFormat","charset","iv","padding"]);

        this.websocket.sendMessage({
            fun: 'Decrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.decryptStep=function(param){
        var name="decryptStep";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["step","keyId","encryptData","dataFormat","charset","iv","padding"]);

        this.websocket.sendMessage({
            fun: 'DecryptStep',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.encryptFile=function(param){
        var name="encryptFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyId","file","encryptFile","iv","padding"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'EncryptFile',
            param: JSON.stringify(p),
            progress: param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptFile);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.decryptFile=function(param){
        var name="decryptFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyId","encryptFile","file","iv","padding"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'DecryptFile',
            param: JSON.stringify(p),
            progress: param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.file);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.closeKey=function(param){
        var name="closeKey";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyId"]);

        this.websocket.sendMessage({
            fun: 'CloseKey',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.digest=function(param){
        var name="digest";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["alg","data","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'Digest',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.digest);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.digestFile=function(param){
        var name="digestFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["alg","file"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'DigestFile',
            param: JSON.stringify(p),
            progress: param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.digest);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.encryptSoft=function(param){
        var name="encryptSoft";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["key","alg","data","dataFormat","charset","iv","padding"]);

        this.websocket.sendMessage({
            fun: 'EncryptSoft',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            },
        });
    };

    MiddlewareWebsocket.prototype.encryptSoftFile=function(param){
        var name="encryptSoftFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["key","alg","file","encryptFile","iv","padding"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'EncryptSoftFile',
            param: JSON.stringify(p),
            progress: param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptFile);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.decryptSoft=function(param){
        var name="decryptSoft";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["key","alg","encryptData","dataFormat","charset","iv","padding"]);

        this.websocket.sendMessage({
            fun: 'DecryptSoft',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.decryptSoftFile=function(param){
        var name="decryptSoftFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["key","alg","file","encryptFile","iv","padding"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'DecryptSoftFile',
            param: JSON.stringify(p),
            progress: param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.file);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.signMessage=function(param){
        var name="signMessage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","data","dataFormat","charset","password","detachData","withTimeStamp","timeStamp","compatP11"
        ]);

        this.websocket.sendMessage({
            fun: 'SignMessage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.message);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.signMessageBatch=function(param){
        var name="signMessageBatch";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","data","dataFormat","charset","password","detachData","withTimeStamp","timeStamp","compatP11"
        ]);

        this.websocket.sendMessage({
            fun: 'SignMessageBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.message);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifyMessage=function(param){
        var name="verifyMessage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["message","data","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'VerifyMessage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifyMessageBatch=function(param){
        var name="verifyMessageBatch";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["message","data","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'VerifyMessageBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getMessageInfo=function(param){
        var name="getMessageInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["message","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'GetMessageInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.messageInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.envelopeMessage=function(param){
        var name="envelopeMessage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["certs","data","dataFormat","charset","alg","encryptUseDevice","compatP11","sn"]);
        this.websocket.sendMessage({
            fun: 'EnvelopeMessage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.message);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.envelopeMessageFile=function(param){
        var name="envelopeMessageFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["certs","file","encryptFile","alg","encryptUseDevice","compatP11","sn"]);
        this.websocket.sendMessage({
            fun: 'EnvelopeMessageFile',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptFile);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.envelopeMessageBigFile=function(param){
        var name="envelopeMessageBigFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["certs","file","encryptFile","alg","encryptUseDevice","compatP11","sn"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'EnvelopeMessageBigFile',
            param: JSON.stringify(p),
            progress: param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.unenvelopeMessage=function(param){
        var name="unenvelopeMessage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["message","dataFormat","charset","password","encryptUseDevice"]);
        this.websocket.sendMessage({
            fun: 'UnEnvelopeMessage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.unenvelopeMessageFile=function(param){
        var name="unenvelopeMessageFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["file","encryptFile","password","encryptUseDevice"]);
        this.websocket.sendMessage({
            fun: 'UnEnvelopeMessageFile',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.file);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.unenvelopeMessageBigFile=function(param){
        var name="unenvelopeMessageBigFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["file","encryptFile","password","encryptUseDevice","message"]);
        if(param.progress){
            p.enableProgress=true;
        }
        this.websocket.sendMessage({
            fun: 'UnEnvelopeMessageBigFile',
            param: JSON.stringify(p),
            progress: param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.file);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.loginDevice=function(param){
        var name="loginDevice";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","app","password"]);
        this.websocket.sendMessage({
            fun: 'LoginDevice',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.isDeviceLogined=function(param){
        var name="isDeviceLogined";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","app"]);
        this.websocket.sendMessage({
            fun: 'IsDeviceLogined',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.loginInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.logoutDevice=function(param){
        var name="logoutDevice";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","app"]);
        this.websocket.sendMessage({
            fun: 'LogoutDevice',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.changePassword=function(param){
        var name="changePassword";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","oldPassword","newPassword","attr"]);
        this.websocket.sendMessage({
            fun: 'ChangePassword',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.genKeyPair=function(param){
        var name="genKeyPair";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","alg","app","container","password"]);
        this.websocket.sendMessage({
            fun: 'GenKeyPair',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.pubKey);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.importKeyPair=function(param){
        var name="importKeyPair";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","encryptKeyPair","app","container"]);
        this.websocket.sendMessage({
            fun: 'ImportKeyPair',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.importCert=function(param){
        var name="importCert";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","cert","app","container","isSign"]);
        this.websocket.sendMessage({
            fun: 'ImportCert',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.agreementBegin=function(param){
        var name="agreementBegin";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","alg","sponsorId"]);
        this.websocket.sendMessage({
            fun: 'AgreementBegin',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sponsorData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.agreementResponse=function(param){
        var name="agreementResponse";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","alg","sponsorCert","sponsorTempPubKey","respondId","sponsorId"]);

        this.websocket.sendMessage({
            fun: 'AgreementResponse',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.respondData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.agreementEnd=function(param){
        var name="agreementEnd";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","respondCert","respondTempPubKey","respondId","handleId"]);
        this.websocket.sendMessage({
            fun: 'AgreementEnd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.keyId);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.fireEvent=function(param){
        var name="fireEvent";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","object"]);
        this.websocket.sendMessage({
            fun: 'FireEvent',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.readFile=function(param){
        var name="readFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["file","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'ReadFile',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.writeFile=function(param){
        var name="writeFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["file","dataFormat","charset","data","newFilePattern"]);

        this.websocket.sendMessage({
            fun: 'WriteFile',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.file);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.downloadFile=function(param){
        var name="downloadFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["file","url","headers","fileExt"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'DownloadFile',
            param: JSON.stringify(p),
            progress:param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.file);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.uploadFile=function(param){
        var name="uploadFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["file","url","partName","headers","form","fileName"]);
        if(param.progress){
            p.enableProgress=true;
        }

        this.websocket.sendMessage({
            fun: 'UploadFile',
            param: JSON.stringify(p),
            progress:param.progress,
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.signTimeStamp=function(param){
        var name="signTimeStamp";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["data","dataFormat","charset","hashB64","context","hashAlg","hasCert"]);
        if(!param.hasCert){
            p.hasCert=true
        }

        this.websocket.sendMessage({
            fun: 'SignTimeStamp',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.timeStamp);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.signTimeStampBatch=function(param){
        var name="signTimeStampBatch";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["data","dataFormat","charset","hashB64","context","hashAlg","hasCert"]);
        if(!param.hasCert){
            p.hasCert=true
        }

        this.websocket.sendMessage({
            fun: 'SignTimeStampBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.timeStamp);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifyTimeStamp=function(param){
        var name="verifyTimeStamp";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["data","dataFormat","charset","hashB64","timeStamp","hashAlg","context"]);

        this.websocket.sendMessage({
            fun: 'VerifyTimeStamp',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifyTimeStampBatch=function(param){
        var name="verifyTimeStampBatch";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["data","dataFormat","charset","hashB64","timeStamp","hashAlg","context"]);

        this.websocket.sendMessage({
            fun: 'VerifyTimeStampBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getTimeStampInfo=function(param){
        var name="getTimeStampInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["timeStamp"]);

        this.websocket.sendMessage({
            fun: 'GetTimeStampInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.timeStampInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.authBegin=function(param){
        var name="authBegin";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["requestId", "deviceId", "sn"]);

        this.websocket.sendMessage({
            fun: 'AuthBegin',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.format=function(param){
        var name="format";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["authResponse", "deviceId","password","retryTimes"]);

        this.websocket.sendMessage({
            fun: 'Format',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.unlock=function(param){
        var name="unlock";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["authResponse", "sn", "password"]);

        this.websocket.sendMessage({
            fun: 'Unlock',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.epsImportSymmKey=function(param){
        var name="epsImportSymmKey";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyIndex", "key", "sn"]);

        this.websocket.sendMessage({
            fun: 'EpsImportSymmKey',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.epsWriteESealData=function(param){
        var name="epsWriteESealData";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sealData", "sn"]);

        this.websocket.sendMessage({
            fun: 'EpsWriteESealData',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.epsReadESealData=function(param){
        var name="epsReadESealData";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyIndex","alg", "sn"]);

        this.websocket.sendMessage({
            fun: 'EpsReadESealData',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.epsEncrypt=function(param){
        var name="epsEncrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyIndex","alg", "sn","iv","divCount","divComponent","inputData"]);

        this.websocket.sendMessage({
            fun: 'EpsEncrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.epsDecrypt=function(param){
        var name="epsDecrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyIndex","alg", "sn","iv","divCount","divComponent","inputData"]);

        this.websocket.sendMessage({
            fun: 'EpsDecrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.epsMac=function(param){
        var name="epsMac";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["keyIndex","alg", "sn","iv","divCount","divComponent","inputData"]);

        this.websocket.sendMessage({
            fun: 'EpsMac',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.showFileDialog=function(param){
        var name="showFileDialog";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["type","title", "dir","filter"]);

        this.websocket.sendMessage({
            fun: 'ShowFileDialog',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.fileNames);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getFileInfo=function(param){
        var name="getFileInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileName"]);

        this.websocket.sendMessage({
            fun: 'GetFileInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.fileInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getFilePath=function(param){
        var name="getFilePath";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","newFilePattern"]);

        this.websocket.sendMessage({
            fun: 'GetFilePath',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.path);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.removeFile=function(param){
        var name="removeFile";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["fileName"]);

        this.websocket.sendMessage({
            fun: 'RemoveFile',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.extEncrypt=function(param){
        var name="extEncrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","pubKey","data","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'ExtEncrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.encryptData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.extDecrypt=function(param){
        var name="extDecrypt";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","priKey","encryptData","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'ExtDecrypt',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.extSign=function(param){
        var name="extSign";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","priKey","pubKey","data","dataFormat","charset"]);

        this.websocket.sendMessage({
            fun: 'ExtSign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.signature);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.extVerify=function(param){
        var name="extVerify";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["deviceId","pubKey","data","dataFormat","charset","signature"]);

        this.websocket.sendMessage({
            fun: 'ExtVerify',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.extGenKeyPair=function(param){
        var name="extGenKeyPair";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["alg","bitLen"]);

        this.websocket.sendMessage({
            fun: 'ExtGenKeyPair',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.setSymmKey=function(param){
        var name="setSymmKey";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["alg","sn","key"]);

        this.websocket.sendMessage({
            fun: 'SetSymmKey',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.keyId);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.setContext=function(param){
        var name="setContext";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","type","provider","svs","cloud","ts"]);

        this.websocket.sendMessage({
            fun: 'SetContext',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifyCert=function(param){
        var name="verifyCert";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["cert","verifyType","context"]);

        this.websocket.sendMessage({
            fun: 'VerifyCert',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifyCertAtTime=function(param){
        var name="verifyCertAtTime";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["cert","time","context"]);

        this.websocket.sendMessage({
            fun: 'VerifyCertAtTime',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.verifyCertSign=function(param){
        var name="verifyCertSign";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["cert","data","dataFormat","charset","signature","verifyType","context"]);

        this.websocket.sendMessage({
            fun: 'VerifyCertSign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.saveEvidence=function(param){
        var name="saveEvidence";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["type","data","verify","context"]);

        this.websocket.sendMessage({
            fun: 'SaveEvidence',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.evidId);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.readEvidence=function(param){
        var name="readEvidence";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["evidId","verify","context"]);

        this.websocket.sendMessage({
            fun: 'ReadEvidence',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.zxq1Enroll=function(param){
        var name="zxq1Enroll";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["handSignType","zoomSize"]);

        this.websocket.sendMessage({
            fun: 'Zxq1Enroll',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.imageInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.getPasswordInfo=function(param){
        var name="getPasswordInfo";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["sn","app"]);

        this.websocket.sendMessage({
            fun: 'GetPasswordInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.info);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MiddlewareWebsocket.prototype.close=function(){
        this.websocket.close()
    };

    $m.MiddlewareWebsocket=MiddlewareWebsocket;

})(HebcaMiddleware);



